<template>
  <v-content>
    <v-container class="fill-height">
      <v-card
        flat
        v-if="validToken"
        min-width="360"
        tile
        style="margin-top: 2%"
        class="d-flex mx-auto flex-wrap"
      >
        <v-form style="width:100%" ref="formpswd" @submit.prevent="submit" v-model="validpswd">
          <v-card-title>
            <!-- <v-avatar> -->
            <img width="55" height="55" class="mr-3" :src="require('@/assets/logo.png')" />
            <!-- </v-avatar> -->
            <span class="title font-weight-light">FIRELOG</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title>
            <span class="title font-weight-bold">{{$t('resetPassword')}}</span>
          </v-card-title>

          <div class="container">
            <v-text-field
              dense
              outlined
              type="password"
              v-model="newpwd"
              :rules="[() => !!newpwd || '', () => (this.newpwd !== this.currentpwd) || 'Password must be new', () => ( /(?=.{8,})/.test(this.newpwd) || 'password weak')]"
              :label="$t('newPassword')"
              required
            ></v-text-field>
            <v-text-field
              dense
              outlined
              type="password"
              v-model="confirmpwd"
              :rules="[() => !!confirmpwd || '', () => (this.newpwd === this.confirmpwd) || '']"
              :label="$t('confirmPassword')"
              required
            ></v-text-field>
          </div>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="changePassword">{{$t("save")}}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import sha256 from "sha256";
export default {
  data: () => {
    return {
      tab: null,
      validToken: false,
      show: false,
      loading: false,
      valid: false,
      newpwd: null,
      confirmpwd: null,
      credentials: {
        username: "",
        inputP: "",
        password: "",
        honeypot: ""
      }
    };
  },
  methods: {
    passwordRules() {
      return [v => !!v || `${this.$t("password")} ${this.$t("required")}`];
    },
    encrypt() {
      this.credentials.password = sha256(this.newpwd);
    },
    changePassword() {
      if (this.$refs.formpswd.validate()) {
        this.encrypt();
        this.$http
          .forgotPasswordReset(
            this.credentials.password,
            this.$route.query.token
          )
          .then(res => {
            this.$router.push({ name: "Login" });
          })
          .catch(error => {
            this.$noty.error(this.$t("error"));
          });
      }
    }
  },
  created() {
    this.$http
      .forgotPasswordChallengeCheck(this.$route.query.token)
      .then(res => {
        this.validToken = true;
      })
      .catch(err => {
        console.log(err);
        this.$router.push({ name: "Login" });
      });
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/authentication/PasswordReset.vue